import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css';

import React from 'react'
import {render} from 'react-dom'

import App from './App'

render(<App/>, document.querySelector('#app'))
